<template>
	<v-dialog
		v-model="dialog"
		scrollable 
		:width="$vuetify.breakpoint.lgAndUp? '33%':'auto'"
		:persistent="saving">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color="info"
				small dark
				v-on="on"
				:disabled="disabled"
				:loading="loadingPermisos"
			>
				{{ isRepresentante? permisos.length: user.permisos || 0 }}
			</v-btn>
		</template>
		<v-card>
			<v-toolbar dense flat color="primary" dark tile>
				<v-btn icon @click="close">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>
					{{
						$vuetify.breakpoint.lgAndUp? 
							`Cambiar permisos de ${user.nombre}`:
							user.nombre
					}}
				</v-toolbar-title>
				<v-spacer/>
				<v-btn icon @click="onRefresh">
					<v-icon>refresh</v-icon>
				</v-btn>
			</v-toolbar>
			<v-divider></v-divider>
			<v-card-text>
				<v-data-table
					:headers="headers"
					:items="permisos"
					loading-text="Cargando permisos"
					:loading="isloading || saving"
					no-data-text="No hemos encontrado datos..."
					locale="es"
					class="elevation-1"
					hide-default-footer
					dense
				>
					<template v-slot:item.permitido="{item}">
						<v-row align="center">
							<v-spacer/>
							<v-checkbox
								v-model="permisosUsuario"
								:value="item"
								:disabled="item.codigo == permisoBoleta.codigo || canMod"
								class="my-3"
								hide-details
							>
							</v-checkbox>
							<v-spacer/>
						</v-row>
					</template>
				</v-data-table>
			</v-card-text>
			<v-card-text  v-if="isRepresentante">
				<v-alert
					border="left"
					colored-border
					type="error"
					elevation="2"
					class="mt-4"
				>
					No puedes modificar los permisos de un representante legal.
				</v-alert>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn color="error" text @click="close">
					Cerrar
				</v-btn>
				<v-spacer/>
				<v-btn 
					color="blue darken-1" dark tile 
					@click="save"
					:disabled="canSave"
				>
					Guardar cambios
				</v-btn>
			</v-card-actions>
		</v-card>
		<v-snackbar
			v-model="alerta.display"
			:color="alerta.type"
		>
			{{ alerta.msg }}
		</v-snackbar>
	</v-dialog>
</template>

<script>

import ApiManager from '@/views/GestionUsuarios/ApiManager';
let apiUser = new ApiManager('apiBoletaSII');

export default {

	name: 'GestorAcceso',
	props: {
		user: {
			type: Object, // String, Number, Boolean, Function, Object, Array
			required: true
		},
		permisos:{
			type: Array,
			default: function(){
				return [];
			}
		},
		loadingPermisos:{
			type: Boolean,
			default: false
		},
		disabled:{
			type: Boolean,
			default: false
		},
	},
	computed: {
		headers () {
			return [
				{
					text: 'Sección',
					value: 'nombre',
					sortable: false
				},
				{
					text: 'Permitido',
					value: 'permitido',
					align: 'center',
					sortable: false
				},
			];
		},
		isRepresentante(){
			return this.user.es_representante == true;
		},
		canSave(){
			return this.isRepresentante || this.isloading || this.saving || this.canMod;
		},
		canMod(){
			return this.user.user == this.$store.getters['usuario/rut'] || this.isRepresentante || this.isloading;
		},
		permisoBoleta(){
			let out = null;
			let permisos = this.permisos || [];
			for( let permiso of permisos ){
				if( permiso.codigo == 'boleta' )	out = permiso;
			}

			if(!!out){
				if( this.permisosUsuario.indexOf(out) <= -1 ){
					this.permisosUsuario.push(out);
				}
			}

			return out;
		}
	},
	data () {
		return {
			dialog: false,
			permisosUsuario: [],
			isloading: false,
			saving: false,
			alerta:{
				display: false,
				msg: '',
				type: ''
			}
		}
	},
	methods:{
		loadPermisosUsuario: async function(){

			let vm = this;

			vm.permisosUsuario = [];

			let permisoBoleta = 'boleta';

			if( vm.isRepresentante ){
				vm.permisosUsuario = vm.permisos;
				return;
			}

			try{
				vm.isloading = true;
				let resp = await apiUser.post('/gestor-user-permisos', {
					contribuyente: vm.$store.getters['empresas/seleccionada'].rut,
					user: vm.user.user
				});

				vm.permisosUsuario = resp.results;

			}catch(err){
				
			}

			vm.isloading = false;
		},
		save: async function(){

			let vm = this;

			try{
				vm.saving = true;
				let resp = await apiUser.post('/gestor-asignar-permisos', {
					contribuyente: vm.$store.getters['empresas/seleccionada'].rut,
					permisos: vm.permisosUsuario,
					user: vm.user.user
				});

				await vm.onReload();

				
				vm.showAlerta('Permisos Guardados.')

			}catch(err){
				if( err.constructor.name !== 'Cancel' )
					vm.showAlerta(`Ha ocurrido un error. (${err})`, 'error');
			}

			vm.saving = false;
		},
		close: function(){
			if(!this.permisos.isloading){
				this.dialog=false;
			}
		},
		onReload: function(){
			this.$emit('onReloadUsers');
			this.loadPermisosUsuario();
		},
		onRefresh: function(){
			this.$emit('onRefreshPermisos');
			this.loadPermisosUsuario();
		},
		showAlerta: function(msg, type="success"){
			this.alerta.display = true;
			this.alerta.msg = msg;
			this.alerta.type = type;
		}
	},
	watch:{
		dialog(val){
			if(val)
				this.loadPermisosUsuario();
		}
	}
}
</script>

<style lang="css" scoped>
</style>